import { Box } from '@hover/blueprint';
import React from 'react';
import styled from 'styled-components';

const Gradient = styled(Box)`
  background: radial-gradient(
      80.52% 29.4% at 6.13% 0%,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    radial-gradient(
      72% 15.32% at 33.6% 64.33%,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 10.64%,
      rgba(114, 153, 196, 0.53) 47.39%,
      rgba(255, 255, 255, 0) 84.13%
    ),
    radial-gradient(
      85.83% 32.47% at 94.27% 0%,
      rgba(36, 125, 220, 0.13) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    radial-gradient(
      101.44% 38.38% at 0% 94.16%,
      rgba(36, 125, 220, 0.21) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #dbdfe5;
`;

export const Background = () => (
  <Gradient height="100%" position="absolute" width="100%" />
);
